import React, { useState } from "react";
import ReactQuill from "react-quill";
import {
  addcorrectAnswer,
  deleteAnswer,
  removeFeedback,
  updateAnswer,
  updateItemQuestion,
  updateQUestionFeedback,
  updateQuizPointValue,
  updateRequiredChange,
} from "../../Redux/Reducer/FormSlices";
import { useDispatch } from "react-redux";
import answerKeyIcon from "../../Assets/answerKeyIcon.png";
import optionTrash from "../../Assets/optionTrash.svg";
import Addiconfontsizes from "../../Assets/Addiconfontsizes.png";
import reduceiconfontsizes from "../../Assets/reduceiconfontsizes.png";
import FeedBackModal from "./FeedBackModal/FeedBackModal";

import editNotificationicon from "../../Assets/editNotificationicon.png";
import deleteNotificationIcon from "../../Assets/deleteNotificationIcon.png";

const ShortAnswerQuestion = ({
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
  generalSettings,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };

  const [showAnswerKey, setShowAnswerKey] = useState(null);
  //handelAddAnswerKey
  const handelAddAnswerKey = (questionId) => {
    setShowAnswerKey(questionId);
  };

  const handleRequiredChange = (questionIndex, containerIndex, value) => {
    dispatch(updateRequiredChange({ questionIndex, containerIndex, value }));
  };

  //add correct answer to redux
  const addCorrectAnswer = () => {
    dispatch(addcorrectAnswer({ questionIndex, containerIndex }));
  };

  // handel delete Answer
  const handelDeleteAnswer = (answerIndex) => {
    dispatch(deleteAnswer({ questionIndex, containerIndex, answerIndex }));
  };

  //update answer
  const handelUpdateAnswer = (answer, answerIndex) => {
    dispatch(
      updateAnswer({ questionIndex, containerIndex, answerIndex, answer })
    );
  };

  const [isShowFeedbackModal, setShowFeedbackModal] = useState(false);

  const closeFeedbackModal = () => {
    setShowFeedbackModal(!isShowFeedbackModal);
  };

  //update answer point value in redux
  const handelChangePointValue = (point) => {
    dispatch(updateQuizPointValue({ point }));
  };

  const [showCorrect, setShowCorrect] = useState("Incorrect answer");
  const handelUpdateFeedBack = (e) => {
    dispatch(
      updateQUestionFeedback({
        questionIndex,
        containerIndex,
        name: e.target.name,
        value: e.target.value,
      })
    );
  };

  const handelEditFeedBack = () => {
    setShowFeedbackModal(true);
  };
  const handelDeleteFeedBack = (name) => {
    dispatch(removeFeedback({ containerIndex, questionIndex, name }));
    // console.log(question);
  };
  return (
    <>
      <FeedBackModal
        isOpen={isShowFeedbackModal}
        onClose={closeFeedbackModal}
        showCorrect={showCorrect}
        setShowCorrect={setShowCorrect}
        onChange={handelUpdateFeedBack}
        answerFeedback={question}
        type={"shortAnswer"}
      />
      {showAnswerKey === question.id ? (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
          >
            <div>List correct answer</div>
            <div className="Questionview_container">
              {questionIndex + 1}.
              <div
                className="Questionview_text"
                dangerouslySetInnerHTML={{ __html: question.question }}
              ></div>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              {question.correctAnswer?.map((currentAnswer, idx) => (
                <div
                  style={{ width: "55%", display: "flex", gap: "1rem" }}
                  key={idx}
                >
                  <input
                    style={{ width: "100%" }}
                    value={currentAnswer}
                    placeholder="type currect answer"
                    className="currence-answer-input-short-answer"
                    onChange={(e) => handelUpdateAnswer(e.target.value, idx)}
                  />
                  <img
                    src={optionTrash}
                    alt="optionTrash"
                    onClick={() => handelDeleteAnswer(idx)}
                  />
                </div>
              ))}
            </div>
            <div
              className="addButton-currect-answer-short-answer"
              onClick={addCorrectAnswer}
            >
              Add a correct answer
            </div>
            <div
              className="answer-key-component-bottom"
              style={{ marginTop: "1rem" }}
            >
              <div
                className="answer-feedback-text"
                onClick={closeFeedbackModal}
              >
                Add answer feedback
              </div>
              <div className="input-text-sizes">
                <input
                  type="number"
                  placeholder=""
                  name="quizSettings.questionPointValue"
                  className="inputValue-for-form-name"
                  value={generalSettings.quizSettings.questionPointValue || ""}
                  onChange={(e) => handelChangePointValue(e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <img src={Addiconfontsizes} alt="addicon" />
                  <img src={reduceiconfontsizes} alt="reduce" />
                </div>
                <div className="text-sizes-model">Points</div>
              </div>
            </div>

            {question.feedBack !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR ALL ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>{question.feedBack}</div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("currentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            {question.inCurrentAnswerFeedback !== "" && (
              <div className="show-feedback-container">
                <div className="show-feedback-container-text-container">
                  <div>FEEDBACK FOR CORRECT ANSWERS</div>
                  <div style={{ color: "#8493B2" }}>
                    {question.inCurrentAnswerFeedback}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <div onClick={handelEditFeedBack}>
                    <img src={editNotificationicon} alt="" />
                  </div>
                  <div
                    onClick={() =>
                      handelDeleteFeedBack("inCurrentAnswerFeedback")
                    }
                  >
                    <img src={deleteNotificationIcon} alt="" />
                  </div>
                </div>
              </div>
            )}
            <div className="done-button-currect-answer">
              <button onClick={() => setShowAnswerKey(null)}>Done</button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="singleQuestion-Container">
            {questionIndex + 1}.
            <ReactQuill
              modules={module}
              theme="snow"
              className={`custom ${
                openQuestion === question.id ? "focus" : ""
              }`}
              onFocus={() => setOpenQuestion(question.id)}
              onBlur={() => setOpenQuestion(null)}
              value={question.question}
              onChange={handleQuestionChange}
            />
          </div>
          <div className="answer-container">{question.placeHolder}</div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: generalSettings?.isQuiz
                ? "space-between"
                : "flex-end",
              marginTop: "2rem",
            }}
          >
            {generalSettings?.isQuiz && (
              <div
                onClick={() => handelAddAnswerKey(question.id)}
                style={{
                  display: "flex",
                  gap: "0.71rem",
                  color: "#1B51BB",
                  alignItems: "center",
                  zIndex: 100,
                }}
              >
                <img src={answerKeyIcon} alt="answerKeyIcon" />
                Answer key
              </div>
            )}
            <div className="required-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={question.required}
                  onChange={(e) =>
                    handleRequiredChange(
                      questionIndex,
                      containerIndex,
                      e.target.checked
                    )
                  }
                />
                <span className="slider"></span>
              </label>
              <p className="required-text">Required</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ShortAnswerQuestion;
